// same text the api sends when a query hits its time limit
export const SEARCH_TOO_BROAD_MESSAGE = 'Search too broad, use a longer phrase';

// the api reports 1000 whenever a page is full rather than counting every match
const APPROXIMATE_TOTAL = 1000;

export const formatTotal = (total: number) => (total >= APPROXIMATE_TOTAL ? `${APPROXIMATE_TOTAL}+` : String(total));

// the api's own message when it sent one; a gateway timeout comes from the load balancer, so it never does
export const searchFailureMessage = (status: number, statusText: string, body: unknown) => {
	if (typeof body === 'string') {
		return body;
	}
	return status === 504 ? SEARCH_TOO_BROAD_MESSAGE : statusText;
};

// a later page failing doesn't mean the phrase is too broad, page 1 already loaded for it
export const pageLoadFailureMessage = (page: number) => `Failed to load page ${page}`;

// the api gives each query 60s, so allow headroom for enrichment and the network before giving up
export const SEARCH_TIMEOUT_MS = 90_000;

// long enough that only a genuinely slow search shows it
export const SLOW_SEARCH_MS = 45_000;
export const SLOW_SEARCH_MESSAGE = 'Please wait, fetching results...';
